import React, { useEffect, useContext, useState, useRef } from "react";
import { toast } from "react-toastify";
import {
  sd_btn_loading,
  sd_dashboard_dob,
  SD_Right_Arrow_white,
  sd_script,
} from "../../../Assets/imageList";

import { SD_Context } from "../../../context/sd-context";
import "../../../Utils/sd-styles/sd-css/main.css";
import "react-toastify/dist/ReactToastify.css";
import Sd_loading from "../../../Components/sd-common-components/sd-loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Utils/sd-styles/sd-datepicker.scss";
import { withRouter } from "react-router";
import moment from "moment";
import ParokshaSevaService from "../../../services/sd-parokshaseva.service";
import Sd_Darshanam_service from "../../../services/sd-darshanam.service";
import PhoneInput from "react-phone-input-2";
import { bookingTimeIsWithinProductTime } from "../../../Utils/sd-slot-management/slot-management";

const Sd_dashboard_quick_booking_darshanam = ({ history }) => {
  const {
    setActive,
    setActivePath,
    currentBookingDarshananam,
    setcurrentBookingDarshananam,
    userData,
    logout,
  } = useContext(SD_Context);
  //-------------------------------------------------------------states--------------------------------------------------------//

  const [mobile, setMobile] = useState("91");
  const [darshanamType, setDarshanamType] = useState("");
  const supportedLanguages = ["en-in", "jp-in", "de-in", "es-in"];
  const [loading, setloading] = useState(true);
  const [noPersons, setNoperons] = useState(1);
  const [selectedLanguage, setSelectedlanguage] = React.useState("en-in");
  const [startDate, setStartDate] = useState("");
  const ref = useRef(null);
  const [slotsData, setSlotsData] = useState([]);
  const [personName, setPersonName] = useState("");
  const [err, setErr] = useState([]);
  const [darshanams, setDarshanams] = useState([]);
  const [slot, setSlot] = useState("");
  const [slotLoading, setSlotLoading] = useState(false);
  const termsList = [
    "Only single person is allowed for single ticket",
    "All the Pilgrims in group ticket have to report together.",
    "Reporting and late reporting of Darshanam (after 1 1/2 hour only on booked slot).",
    "The pilgrims should not carry any luggage/cell phones/electronic gadgets while reporting.",
    `After completion of booking, cancellation / advancement / postponement are not accepted. `,
    "Entry with foot wear is not permitted into the queue lines, mada streets and Temple.",
    "SBMSD reserves the right of cancellation of Darshan under Special Circumstances.",
  ];
  const templeID = process.env.REACT_APP_TEMPLE ?? "SBMSD";
  const [highlightDates, setHighlightDates] = useState([]);
  const [excludeDates, setExcludeDates] = useState([]);

  //-------------------------------------------------------------useeffect--------------------------------------------------------//

  useEffect(() => {
    setActive("quick-booking-darshanam");
    setActivePath("Quick Booking - Darshanam");
    let path = new URLSearchParams(history?.location?.search).get("state");
    if (path === "clear") {
      setcurrentBookingDarshananam(null);
    }
    if (
      supportedLanguages.includes(
        history?.location?.pathname?.split?.("/")?.[1]
      )
    ) {
      setSelectedlanguage(history?.location?.pathname?.split?.("/")?.[1]);
    } else {
      setSelectedlanguage("en-in");
    }
    localStorage.removeItem("payment-context");

    getData();
  }, []);
  //-------------------------------------------------------------useeffect--------------------------------------------------------//

  //-------------------------------------------------------------functions--------------------------------------------------------//

  const getData = async () => {
    try {
      let res = await Sd_Darshanam_service.getAllvalidOnline(templeID);
      // Filter out Sparsha Darshanam - show all other darshanam types
      const filteredDarshanams =
        res?.filter(
          (item) => !item.name?.includes("Sparsha Darshanam") && !item?.disabled
        ) || [];
      setDarshanams(filteredDarshanams);
      if (res?.filter((e) => !e?.disabled)) {
        history?.push(
          `/${selectedLanguage}/devotee-app/quick-booking/quick-darshanam?state=clear`
        );
      }
      if (currentBookingDarshananam) {
        setNoperons(currentBookingDarshananam?.noPersons);
        setStartDate(currentBookingDarshananam?.startDate);
        setDarshanamType(currentBookingDarshananam?.darshanamType);
        setSlot(currentBookingDarshananam?.slot);
        setSlotsData(currentBookingDarshananam?.slotsData);
        // Get the first person's name from personStates if exists
        if (currentBookingDarshananam?.personStates?.length > 0) {
          const firstName =
            currentBookingDarshananam.personStates[0]?.name || "";
          setPersonName(firstName);
        }
        setMobile(currentBookingDarshananam?.mobile);
        setExcludeDates([]);
        setHighlightDates([]);
        getQuota(currentBookingDarshananam?.darshanamType);
      } else {
        // Auto-fill mobile number from userData
        if (userData?.phone) {
          const phoneNumber = userData.phone.replace("+", "");
          setMobile(phoneNumber || "91");
        }
        // Auto-fill name from userData
        if (
          userData?.firstName ||
          userData?.lastName ||
          userData?.displayName
        ) {
          const userName =
            userData?.firstName && userData?.lastName
              ? `${userData.firstName} ${userData.lastName}`
              : userData?.displayName || "";
          if (userName) {
            setPersonName(userName);
          }
        }
      }
      setloading(false);
    } catch (e) {
      toast.warning(e.message);
      if (e.message === "Session Expired") {
        logout();

        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/quick-booking/quick-darshanam?state=clear`
        );
      }
      setloading(false);
    }
  };

  const getDates = (startDate, endDate, quotaDates) => {
    let date = startDate;
    let dates = [];
    while (date <= endDate) {
      if (
        !quotaDates?.includes(moment(date, "YYYY-MM-DD").format("YYYY-MM-DD"))
      ) {
        dates.push(new Date(date));
      }
      date = moment(date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");
    }
    setExcludeDates([...dates]);
  };

  const getQuota = async (data) => {
    setSlotLoading(true);
    let quotaDates = [];
    let availableDates = [];
    let availableDatesString = [];
    let almostBookedDates = [];
    let almostBookedDatesString = [];
    let notAvailableDates = [];
    let notAvailableDatesString = [];
    try {
      let res = await Sd_Darshanam_service.getDailyQuota(
        moment().add(data?.minOnlineHours, "hours").format("YYYY-MM-DD"),
        moment().add(data?.maxOnlineHours, "hours").format("YYYY-MM-DD"),
        Number(data?.id),
        data?.onlineEnabled,
        templeID
      );
      if (res?.length > 0) {
        if (res?.length > 0) {
          if (Number(data?.id) !== Number(res[0]?.productSlot?.product?.id)) {
            res = [];
            setDarshanamType([]);
          }
        }
      }

      setSlotsData(
        res?.filter((item) =>
          bookingTimeIsWithinProductTime(
            item?.date,
            item?.productSlot?.startTime,
            data?.minOnlineHours || 1,
            data?.maxOnlineHours
          )
        )
      );
      res?.map((item) => {
        quotaDates.push(item?.date);
        if (item?.quantity > 0) {
          if (
            !bookingTimeIsWithinProductTime(
              item?.date,
              item?.productSlot?.startTime,
              data?.minOnlineHours || 1,
              data?.maxOnlineHours
            )
          ) {
            notAvailableDates.push(new Date(item?.date));
            notAvailableDatesString.push(new Date(item?.date).toString());
          } else if (
            Number(item?.availableQuantity / item?.quantity) * 100 >
            50
          ) {
            availableDates.push(new Date(item?.date));
            availableDatesString.push(new Date(item?.date).toString());
            if (
              notAvailableDatesString.includes(new Date(item?.date).toString())
            ) {
              let index = notAvailableDatesString.indexOf(
                new Date(item?.date).toString()
              );
              notAvailableDates.splice(index, 1);
              notAvailableDatesString.splice(index, 1);
            }
          } else if (
            Number(item?.availableQuantity / item?.quantity) * 100 <= 50 &&
            Number(item?.availableQuantity / item?.quantity) * 100 > 0
          ) {
            almostBookedDates.push(new Date(item?.date));
            almostBookedDatesString.push(new Date(item?.date).toString());
            if (
              notAvailableDatesString.includes(new Date(item?.date).toString())
            ) {
              let index = notAvailableDatesString.indexOf(
                new Date(item?.date).toString()
              );
              notAvailableDates.splice(index, 1);
              notAvailableDatesString.splice(index, 1);
            }
          } else {
            if (
              !availableDatesString.includes(new Date(item?.date).toString())
            ) {
              if (
                !almostBookedDatesString.includes(
                  new Date(item?.date).toString()
                )
              ) {
                notAvailableDates.push(new Date(item?.date));
                notAvailableDatesString.push(new Date(item?.date).toString());
              }
            }
          }
        } else {
          notAvailableDates.push(new Date(item?.date));
          notAvailableDatesString.push(new Date(item?.date).toString());
        }
      });
      notAvailableDates?.map((date) => {
        if (
          availableDatesString.includes(date.toString()) ||
          almostBookedDatesString.includes(date.toString())
        ) {
          let index = notAvailableDatesString.indexOf(date.toString());
          notAvailableDates.splice(index, 1);
          notAvailableDatesString.splice(index, 1);
        }
      });
      setHighlightDates([
        { "react-datepicker__day--highlighted-custom-1": availableDates },
        { "react-datepicker__day--highlighted-custom-2": almostBookedDates },
        { "react-datepicker__day--highlighted-custom-3": notAvailableDates },
      ]);
      getDates(
        moment().add(data?.minOnlineHours, "hours").format("YYYY-MM-DD"),
        moment().add(data?.maxOnlineHours, "hours").format("YYYY-MM-DD"),
        quotaDates
      );
      setSlotLoading(false);
    } catch (e) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      toast.error(e.message);
      if (e.message === "Session Expired") {
        logout();

        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/quick-booking/quick-darshanam?state=clear`
        );
      }
      setSlotLoading(false);

      return;
    }
  };

  const handleSubmit = async () => {
    setloading(true);
    let a = true;
    if (a) {
      let data = [...err];
      if (startDate === "") {
        data.push({ type: "date", msg: "Please select a date" });
      }
      if (darshanamType === "") {
        data.push({ type: "type", msg: "Please select a darshanam type" });
      }
      if (slot === "") {
        data.push({ type: "slot", msg: "Please select a slot" });
      }
      if (mobile.substring(0, 2) === "91") {
        if (mobile.length !== 12) {
          data.push({ type: "phone", msg: "Invalid mobile number" });
        }
      } else {
        if (mobile.length < 8) {
          data.push({ type: "phone", msg: "Invalid mobile number" });
        }
      }
      // Validate person name
      if (personName === "") {
        data.push({
          type: "name",
          msg: "Please enter a name",
        });
      } else {
        if (personName.length < 3) {
          data.push({
            type: "name",
            msg: "Minimum 3 characters",
          });
        }
      }
      setErr(data);
      if (data.length !== 0) {
        setloading(false);
        ref.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

        return;
      }
    }

    try {
      // Create person details array: first person with entered name, rest with "-"
      let arrayEx = [];
      for (let i = 0; i < noPersons; i++) {
        arrayEx.push({
          personName: i === 0 ? personName : "-",
          documentType: "aadhar",
          documentId: "000000000000", // Default placeholder for quick booking
        });
      }

      let schema = {
        cartContains: ["darshanam"],
        darshanamBookings: [
          {
            darshanamSlotId: slot?.productSlot?.id,
            bookingDate: moment(startDate).format("YYYY-MM-DD"),
            phoneNumber: `+${mobile}`,
            personDetails: arrayEx,
          },
        ],
        returnPriceStats: true,
      };

      let res = await ParokshaSevaService.bookings(schema, templeID);
      if (res) {
        // Create personStates array for backward compatibility
        let personStatesArray = [];
        for (let i = 0; i < noPersons; i++) {
          personStatesArray.push({
            id: i + 1,
            name: i === 0 ? personName : "-",
          });
        }
        let data = {
          darshanamType,
          startDate,
          noPersons,
          personStates: personStatesArray,
          slot,
          slotsData,
          mobile,
          templeID,
          res,
        };
        setcurrentBookingDarshananam(data);
        setloading(false);

        history?.push(
          `/${selectedLanguage}/devotee-app/quick-booking/quick-darshanam/confirm`
        );
        setHighlightDates([]);
        setExcludeDates([]);
      }
    } catch (e) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      toast.error(e.message);

      if (e.message === "Session Expired") {
        logout();

        history?.push(
          `/${selectedLanguage}/devotee/signin?to=devotee-app/quick-booking/quick-darshanam`
        );
      }
      setloading(false);
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      return;
    }
  };

  const getSlotsDetails = () => {
    if (slotsData?.length === 0 || !slotsData) {
      return <p>No Slots available</p>;
    }
    return slotsData
      ?.filter((item) => moment(startDate).format("YYYY-MM-DD") === item?.date)
      ?.sort((a, b) =>
        a.productSlot?.startTime.localeCompare(b.productSlot?.startTime)
      )
      ?.map((item, i) => {
        if (noPersons > item?.availableQuantity) {
          return;
        }
        return (
          <div
            key={i + "slots-d"}
            onClick={() => {
              if (noPersons > item?.availableQuantity) {
                return;
              }
              setSlot(item);
              if (err?.find((e) => e.type === `slot`)) {
                let data = err.filter((e) => e.type !== "slot");
                setErr(data);
              }
            }}
          >
            <div
              className="sd-darshanam-box text-center"
              style={{
                display: "flex",
                alignItems: "center",
                border:
                  err.find((e) => e.type === "slot") ||
                  noPersons > item?.availableQuantity
                    ? "1px solid red"
                    : "",
              }}
              onClick={() => {
                if (noPersons > item?.availableQuantity) {
                  return;
                }
                setSlot(item);
                if (err?.find((e) => e.type === `slot`)) {
                  let data = err.filter((e) => e.type !== "slot");
                  setErr(data);
                }
              }}
            >
              <p
                className="sd-darshanam-time"
                style={{ marginBottom: "0px", maxWidth: "85px" }}
              >
                <span style={{ marginRight: "3px", fontWeight: "600" }}>
                  {item?.availableQuantity}
                </span>
                <span style={{ fontWeight: "400" }}> Available </span>
              </p>
              <div className="sd-side-heading-2 sd-acc">
                <span
                  style={{
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                  }}
                >
                  Slot-(
                  {moment(item?.productSlot?.startTime, "HH:mm:ss").format(
                    "hh:mm A"
                  )}
                  ){" "}
                </span>
              </div>
              <input
                className="sd-darshanam-radio"
                type="radio"
                id={"slot" + 11}
                name=""
                value={slot}
                onClick={() => {
                  if (noPersons > item?.availableQuantity) {
                    return;
                  }
                  setSlot(item);
                  if (err?.find((e) => e.type === `slot`)) {
                    let data = err.filter((e) => e.type !== "slot");
                    setErr(data);
                  }
                }}
                checked={slot.id === item?.id}
              />
            </div>
          </div>
        );
      });
  };

  function addDays(date, days) {
    const copy = new Date(Number(date));
    copy.setDate(date.getDate() + days);
    return copy;
  }

  //-------------------------------------------------------------functions--------------------------------------------------------//

  return (
    <div
      className="col-xs-12 col-sm-12 col-md-9 col-lg-9 sd-dashboard"
      style={{
        minHeight: document.getElementById("side-menu")?.offsetHeight,
      }}
    >
      {!loading ? (
        <div className="sd-profile sd-seva-form">
          <h2 className="sd-side-heading fw400">
            <span className="fw700" ref={ref}>
              Quick Darshanam{" "}
            </span>
            Booking
          </h2>

          <div className="clearfix">
            {darshanams?.filter((e) => !e?.disabled)?.length === 0 ? (
              <p className="flex-c w-100 border-c pb-30  pt-20 br-4">
                <img
                  src={sd_script}
                  alt="#"
                  height="80px"
                  width="80px"
                  className="mr-5 mb-5 opace"
                />
                We are sorry to say that online darshanam booking is temporarily
                unavailable. We regret the inconvenience.
              </p>
            ) : (
              <form className="sd-form">
                <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12  xssm-pr-0 pl-0 ">
                  <label>
                    Select Darshanam Type<span className="sd-imp">*</span>
                  </label>
                  <div className="clearfix">
                    {darshanams?.map((item, i) => {
                      if (item?.disabled) {
                        return;
                      }
                      return (
                        <div
                          className="col-xs-12 col-sm-12 col-md-6 col-lg-6  xssm-pr-0 pl-0"
                          key={i + "darshanamtype"}
                        >
                          <div
                            className={
                              err.find((e) => e.type === "type")
                                ? " sd-red sd-radio-select"
                                : "sd-radio-select"
                            }
                            onClick={() => {
                              if (err?.find((e) => e.type === `type`)) {
                                let data = err.filter((e) => e.type !== "type");
                                setErr(data);
                              }
                              setSlot("");
                              setSlotsData([]);
                              setStartDate("");
                              item.name ===
                                "Sparsha Darshanam ( Single Person Only)" &&
                                setNoperons(1);
                              setDarshanamType(item);
                              setExcludeDates([]);
                              setHighlightDates([]);
                              getQuota(item);
                            }}
                          >
                            <input
                              type="radio"
                              name="optradio1"
                              id={`Annadanam${i}`}
                              checked={
                                darshanamType?.name === item?.name
                                  ? true
                                  : false
                              }
                            />
                            <label
                              htmlFor={`Annadanam${i}`}
                              className="radio-inline"
                              onClick={() => {
                                if (err?.find((e) => e.type === `type`)) {
                                  let data = err.filter(
                                    (e) => e.type !== "type"
                                  );
                                  setErr(data);
                                }
                                setDarshanamType(item);
                              }}
                            >
                              <p>
                                {item?.name}
                                <br></br>
                                <span>Rs. {item.price}.00</span>
                              </p>
                            </label>
                          </div>
                        </div>
                      );
                    })}
                    <p className="sd-EM mr-35" style={{ left: "0" }}>
                      {err?.find((e) => e.type === `type`)?.msg}
                    </p>
                  </div>
                </div>
                <hr className="clearfix"></hr>
                <div className="sd-profile">
                  <div className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4 xssm-pr-0 pl-0">
                    <label>
                      Select Date<span className="sd-imp">*</span>
                    </label>

                    <div
                      className={
                        err?.find((e) => e.type === `date`)
                          ? "sd-dob customDatePickerWidth sd-red"
                          : startDate !== ""
                          ? "sd-date-voilet sd-dob customDatePickerWidth"
                          : "sd-dob customDatePickerWidth"
                      }
                    >
                      <DatePicker
                        allowSameDay={false}
                        placeholderText="DD/MM/YYYY"
                        dateFormat={"dd/MM/yyyy"}
                        showDisabledMonthNavigation
                        style={{
                          width: "90%",
                          border: "none",
                          backgroundColor: "blue",
                        }}
                        highlightDates={highlightDates}
                        excludeDates={excludeDates}
                        minDate={addDays(
                          new Date(),
                          darshanamType?.minOnlineHours / 24
                        )}
                        maxDate={addDays(
                          new Date(),
                          darshanamType?.maxOnlineHours / 24
                        )}
                        calendarIcon={<img src={sd_dashboard_dob} alt="" />}
                        clearIcon={null}
                        selected={startDate}
                        onChange={(date) => {
                          if (darshanamType === "" || !darshanamType) {
                            toast.error("Please select darshanam type");
                            return;
                          }
                          if (
                            err.find(
                              (e) => e.type === "date" || e.type === "server"
                            )
                          ) {
                            let data = err.filter((e) => {
                              if (e.type !== "date" && e.type !== "server") {
                                return e;
                              }
                            });
                            setErr(data);
                          }
                          setStartDate(date);
                        }}
                      >
                        <div className="sd-quota">
                          <div className="sd-quota-div">
                            <p
                              style={{
                                backgroundColor: "rgb(0, 207, 0)",
                                color: "rgb(0, 207, 0)",
                              }}
                            ></p>
                            Available
                          </div>
                          <div className="sd-quota-div">
                            <p
                              style={{
                                backgroundColor: "orangered",
                                color: "orangered",
                              }}
                            ></p>
                            Almost Booked
                          </div>
                        </div>
                        <div className="sd-quota">
                          <div className="sd-quota-div">
                            <p
                              style={{
                                backgroundColor: "rgb(201, 0, 0)",
                                color: "rgb(201, 0, 0)",
                              }}
                            ></p>
                            Not Available
                          </div>
                          <div className="sd-quota-div">
                            <p
                              style={{
                                backgroundColor: "rgb(117,117,117)",
                                color: "rgb(117,117,117)",
                              }}
                            ></p>
                            Quota Not Released
                          </div>
                        </div>
                      </DatePicker>
                    </div>
                    <p className="sd-EM mr-15">
                      {err?.find((e) => e.type === `date`)?.msg}
                    </p>
                  </div>

                  <div className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4  xssm-pl-0 xssm-pr-0">
                    <label>
                      Number of Person(s)<span className="sd-imp">*</span>
                    </label>
                    <select
                      className={
                        noPersons !== ""
                          ? "form-control sd-voilet"
                          : "form-control"
                      }
                      onChange={(e) => {
                        setNoperons(e.target.value);
                        setSlot("");
                      }}
                      value={noPersons}
                    >
                      <option key={"1"} value={"1"}>
                        1
                      </option>
                      {darshanamType.name !==
                        "Sparsha Darshanam ( Single Person Only)" && (
                        <>
                          {" "}
                          <option key={"2"} value={"2"}>
                            2
                          </option>
                          <option key={"3"} value={"3"}>
                            3
                          </option>
                          <option key={"4"} value={"4"}>
                            4
                          </option>
                          <option key={"5"} value={"5"}>
                            5
                          </option>
                        </>
                      )}
                    </select>
                    <p style={{ color: "#181818", fontWeight: "600" }}>
                      Free for Children under 10 years
                    </p>
                  </div>
                  <div className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4  xssm-pr-0 pl-0">
                    <label>
                      Mobile Number<span className="sd-imp">*</span>
                    </label>
                    <div className={"sd-profile-mobile"}>
                      <PhoneInput
                        inputExtraProps={{
                          autoFocus: true,
                          enableSearch: true,
                          countryCodeEditable: false,
                        }}
                        onlyCountries={["in"]}
                        placeholder="Enter Your 10 digit mobile number"
                        maxLength="15"
                        countryCodeEditable={false}
                        containerClass={
                          err?.find((e) => e.type === "phone")
                            ? "sd-phone-voilet sd-red"
                            : mobile !== ""
                            ? "sd-phone-voilet"
                            : ""
                        }
                        country="in"
                        value={mobile}
                        onChange={(e) => {
                          if (
                            err?.find(
                              (e) => e.type === "phone" || e.type === "common"
                            )
                          ) {
                            let array = err.filter((e) => {
                              if (e.type !== "phone" && e.type !== "common") {
                                return e;
                              }
                            });
                            setErr(array);
                          }
                          setMobile(e);
                        }}
                      />
                      <p className="d-EM ">
                        {err.find((e) => e.type === "phone")
                          ? err.find((e) => e.type === "phone")?.msg
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>
                {slotsData?.length !== 0 && startDate ? (
                  <>
                    <hr className="clearfix"></hr>

                    <div
                      className="clearfix sd-darshanam-content"
                      style={{ position: "relative" }}
                    >
                      <br />
                      {getSlotsDetails()}
                      <p
                        style={{
                          position: "absolute",
                          top: "-12px",
                          left: "0px",
                          textAlign: "right",
                          color: "red",
                        }}
                      >
                        {err?.find((e) => e.type === `slot`)?.msg}
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    {startDate && !slotLoading ? (
                      <>
                        <hr className="clearfix"></hr>{" "}
                        <div
                          className="clearfix sd-darshanam-content"
                          style={{ position: "relative", color: "red" }}
                        >
                          No Slots available on{" "}
                          {moment(startDate).format("DD-MM-YYYY")}
                        </div>
                      </>
                    ) : (
                      startDate && (
                        <>
                          <hr className="clearfix"></hr>{" "}
                          <div
                            className="clearfix sd-darshanam-content"
                            style={{ position: "relative" }}
                          >
                            Fetching slots...Please wait{" "}
                          </div>
                        </>
                      )
                    )}
                  </>
                )}
                <div className="clearfix">
                  <hr className="clearfix"></hr>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4  xssm-pr-0 pl-0">
                  <label>
                    Name<span className="sd-imp">*</span>
                  </label>
                  <input
                    maxLength="30"
                    type="text"
                    autoComplete="new-password"
                    placeholder="Please enter your name."
                    className={
                      err?.find((e) => e.type === "name")
                        ? "form-control sd-red"
                        : personName !== ""
                        ? "form-control sd-voilet"
                        : "form-control"
                    }
                    value={personName}
                    onChange={(e) => {
                      if (
                        /^[a-zA-Z ]*$/.test(
                          String(e.target.value) || e.target.value === ""
                        )
                      ) {
                        if (err.find((e) => e.type === "name")) {
                          let data = err.filter((e) => e.type !== "name");
                          setErr(data);
                        }
                        setPersonName(e.target.value);
                      }
                    }}
                  />
                  <p className="sd-EM mr-15 ">
                    {err.find((e) => e.type === "name")?.msg}
                  </p>
                </div>
                <div className="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12  xssm-pl-0 pr-0">
                  <p
                    className="ml--15"
                    style={{
                      color: "#181818",
                      fontWeight: "600",

                      whiteSpace: "pre-wrap",
                    }}
                  >
                    Note: Pilgrims who book for Darshanam should bring the
                    printed copy of their receipt.{" "}
                  </p>
                  <ol className="sd-terms-list">
                    {termsList.map((item, i) => {
                      return (
                        <li className="active" key={i + "terms-d"}>
                          <a style={{ paddingRight: "3px" }}>{item}</a>
                        </li>
                      );
                    })}
                  </ol>
                </div>

                <hr className="clearfix"></hr>

                <div className="clearfix mt-50">
                  <a
                    className="sd-btn-orange"
                    onClick={() => {
                      if (!loading) {
                        handleSubmit();
                      }
                    }}
                  >
                    Confirm Booking{" "}
                    {loading ? (
                      <img
                        src={sd_btn_loading}
                        alt=".."
                        className="sd-arrow-btn ml-5 h-20"
                      />
                    ) : (
                      <img
                        className="sd-arrow-btn ml-5"
                        src={SD_Right_Arrow_white}
                      />
                    )}
                  </a>
                </div>
              </form>
            )}
          </div>
        </div>
      ) : (
        <Sd_loading />
      )}
    </div>
  );
};
export default withRouter(Sd_dashboard_quick_booking_darshanam);
